import { takeLatest, call } from "redux-saga/effects";

import AuthService from "../../../services/Auth/AuthService";
import * as types from "../actionTypes";

export function* refreshAuthTokenWatcherSaga() {
  yield takeLatest(types.AUTH_API_REFRESH_ACCESS_TOKEN, workerSaga);
}

export function* workerSaga({ logout, setSessionExpired }) {
  let success = false;

  try {
    const status = yield call(AuthService.refreshAuthToken);

    if (status === "SUCCESS") {
      success = true;
    }
  } catch (error) {
    success = false;
  }

  if (!success) {
    sessionStorage.removeItem("user");
    logout().then(() => {
      setSessionExpired(true);
    });
  }
}
